import { Theme } from "@mui/material/styles";

/* eslint-disable quote-props */
export const cardStyle = () => ({
  textAlign: "center",
  borderRadius: "8px",
  boxShadow: "none",
  width: "99%",
  height: "100%",
  border: "1px solid #E8DFD7",
  "&:hover": {
    transform: "scale(1.01)",
    border: "1px solid #E5AF0A",
  },
});

export const cardStyleActive = (theme: Theme) => ({
  textAlign: "center",
  borderRadius: "8px",
  boxShadow: "none",
  width: "100%",
  height: "100%",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.light,
});

export const cardInnerStyle = () => ({
  boxShadow: "none",
  display: "flex",
  alignItems: "center",
  justifyItems: "center",
  gap: 2,
});

export const boxIconContainer = (theme: Theme) => ({
  display: "inline-block",
});

export const iconStyle = (theme: Theme) => ({
  width: "80px",
  height: "80px",
  margin: "1rem",
  borderRadius: "50%",
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.light,
  "& svg": {
    fontSize: 32,
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
